<template>
	<div>
		<h1 class="view-title">
			MOTORISTAS - LISTAGEM
		</h1>

		<div class="inner-content shadowed">
			<div class="inner-content-title">
				Lista

				<div class="filter-wrapper">
					<input class="filter-input" type="text" placeholder="Buscar" v-model="search" @keydown.enter.prevent="load(true)" />
					<i class="fa fa-fw fa-search"></i>
				</div>
			</div>

			<div class="row">
				<div class="col-xs">
					
					<Table 
					:loading="loading"
					:headers="headers" 
					:ordering="ordering" 
					:list="list" 
					:page="page"
					:per_page="20" 
					:total="total" 
					@next="() => { page++; load(); }" 
					@prev="() => { page--; load(); }"
					v-slot="{item}">

						<button class="button-edit" @click="current = item" title="Editar">
							<i class="fa fa-fw fa-edit"></i>
						</button>

						<button class="button-edit" @click="resend_sms(item.document, item.phone)" title="Re-enviar código de alteração de senha">
							<i class="fa fa-fw fa-sms"></i>
						</button>

						<button class="button-edit" @click="generate_strong_password(item.id)" title="Gerar nova senha">
							<i class="fa fa-fw fa-unlock-alt"></i>
						</button>

						<button class="button-remove" @click="remove(item.id)" title="Excluir">
							<i class="fa fa-fw fa-trash"></i>
						</button>

					</Table>

				</div>

			</div>
		</div>


		<AdminDriversForm v-if="current" :current="current" />


	</div>
</template>

<script>
import Api from "@/lib/Api";

import Table from '@/components/Table';
import AdminDriversForm from './AdminDrivers/AdminDriversForm';

export default {
	name: "AdminDrivers",

	components: { Table, AdminDriversForm },

	data: function() {
		return {
			search: "",

			loading: true,
			list: [],
			page: 0,
			total: 0,
			headers: {
				id: "#",
				document: "CPF/CNPJ",
				name: "Nome",
				phone: "Telefone",
				email: "E-mail"
			},
			ordering: [],

			current: false,
		};
	},

	mounted: function() {
		this.load();
	},

	activated: function() {
		this.load();
	},

	methods: {
		load: async function(is_search) {
			let form = {};

			if (this.search) form.search = this.search

			if (is_search) this.page = 0;

			form.page = this.page;

			this.list = [];

			this.loading = true;
			let res = await Api.post_admin("driver/list", form);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.list = res.data;
			this.total = res.total;
		},


		remove: async function(id) {
			let confirm = await this.$alert.confirm("Tem certeza que deseja remover o motorista?");
			if (!confirm) return;

			this.loading = true;
			let res = await Api.post_admin("driver/delete", {id: id});
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.$notification.success("Motorista removido com sucesso.");
			this.load();
		},


		resend_sms: async function(document, phone) {
			let confirm = await this.$alert.confirm("Um sms de alteração de senha será enviado para: " + phone + ". Continuar?");
			if (!confirm) return;

			this.loading = true;
			let res = await Api.post_raw(this.$api.host + "/driver/auth/request-reset-password", {
				document: document
			}, {});
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.$notification.success("SMS de alteração de senha re-enviado com sucesso.");
		},


		generate_strong_password: async function(id) {
			let confirm = await this.$alert.confirm("Será gerada uma nova senha segura para o motorista. Alterar senha do motorista?");
			if (!confirm) return;

			this.loading = true;
			let res = await Api.post_admin("driver/gerenerate-password", { id: id });
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.$alert.alert("Nova senha do motorista: " + res.data);
		}
	}
}
</script>

<style scoped>

.filter-wrapper {
	width: 200px;
	position: relative;
	float: right;
	height: 50px;
}
.filter-wrapper > i {
	position: absolute;
	top: 22px;
	left: 8px;
}

.filter-input {
	height: 30px;
	width: 100%;
	padding-left: 30px;
}
</style>